import React from 'react';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Button } from '@vio/atlas/Button';
import { Box } from '@vio/atlas/helpers/Box';
import { Icon } from '@vio/atlas/Icon';
import { getAnonymousId } from '@daedalus/core/src/_web/anonymousId';
import { getQueryStringObject } from '@daedalus/core/src/_web/utils/url';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { defaultLanguage } from '@daedalus/core/src/localization/services/locale';
import { Room, RoomOffer } from '@findhotel/sapi';
import { getApplication, getBookingStatus } from '../../modules/selector';
import { getBookingManagementUrl } from '../../utils/url';
import { HotelCard } from '../HotelCard';
import { GradientBackground } from './GradientBackground';
import { HeaderContent } from './HeaderContent';
import { NextSteps } from './NextSteps';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w11ugyt4",
  propsAsIs: false
});
const ContentContainer = /*#__PURE__*/styled('div')({
  name: "ContentContainer",
  class: "cw6lckk",
  propsAsIs: false
});
const CloseButtonWrapper = /*#__PURE__*/styled('div')({
  name: "CloseButtonWrapper",
  class: "ctikk5j",
  propsAsIs: false
});
const _exp11 = /*#__PURE__*/() => Button;
const CloseButton = /*#__PURE__*/styled(_exp11())({
  name: "CloseButton",
  class: "cwrskk7",
  propsAsIs: true
});
interface Props {
  expiresAt: string;
  hotelName: string;
  checkIn: string;
  checkOut: string;
  roomsSplit: string;
  imageUrl: string;
  rating: number | undefined;
  room: Room | undefined;
  errored: boolean;
  offer: RoomOffer | undefined;
  isOverlayContent?: boolean;
  onCloseOverlay: () => void;
}
export const ConfirmationContent: React.FC<Props> = ({
  expiresAt,
  errored,
  hotelName,
  checkIn,
  checkOut,
  offer,
  room,
  imageUrl,
  rating,
  roomsSplit,
  isOverlayContent,
  onCloseOverlay
}) => {
  const urlParams = getQueryStringObject();
  const bookingStatus = useSelector(getBookingStatus);
  const {
    bookingManagementUrl
  } = useSelector(getApplication);
  const anonymousId = getAnonymousId();
  const bookingId = bookingStatus?.id;
  const handleViewFrozenDeals = () => {
    if (!bookingId || !bookingManagementUrl) return;
    const myBookingUrl = getBookingManagementUrl({
      hostUrl: bookingManagementUrl,
      bookingId,
      anonymousId,
      locale: urlParams.locale as string || defaultLanguage
    });
    location.assign(myBookingUrl);
  };
  return <Wrapper>
      <GradientBackground />
      <CloseButtonWrapper>
        <CloseButton variant="transparent" iconStart={<Icon name={'Close'} />} onClick={onCloseOverlay} />
      </CloseButtonWrapper>
      <ContentContainer className={cx(isOverlayContent && 'isOverlayContent')}>
        <HeaderContent expiresAt={expiresAt} />
        <Box paddingTop="s500" paddingBottom="s600">
          <HotelCard hotelName={hotelName} checkIn={checkIn} checkOut={checkOut} roomsSplit={roomsSplit} room={room} offer={offer} imageUrl={imageUrl} rating={rating} shouldShowPayNow={false} />
        </Box>
        {!errored && <div>
            <NextSteps expiresAt={expiresAt} />
            <Button dataId="ViewFrozenDeal" variant="secondary" fullWidth size="xl" onClick={handleViewFrozenDeals}>
              <FormattedMessageWrapper id="dealFreeze.viewFrozenDeals" defaultMessage="Manage frozen deals" />
            </Button>
          </div>}
      </ContentContainer>
    </Wrapper>;
};

require("./ConfirmationContent.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ConfirmationContent.tsx");